var _defs, _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _g3, _g4, _path7, _path8, _path9, _g5, _path0, _path1, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "empty-states_illustration_accomplishment_cleared",
    "data-name": "empty-states_illustration_accomplishment,cleared",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 179.579,
    height: 181.834,
    viewBox: "0 0 179.579 181.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.027,
    y1: 0.386,
    x2: 1.012,
    y2: 0.708,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#e7eef8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#d2ddf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#c5d3ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1d0ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.002,
    y1: 0.5,
    x2: 1.002,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7c7de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.002,
    y1: 0.5,
    x2: 1.002,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.02,
    y1: 0.458,
    x2: 1.016,
    y2: 0.72,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7c7de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.143,
    y1: 0.964,
    x2: 1.089,
    y2: 0.319,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.986,
    y1: 0.246,
    x2: 0.117,
    y2: 0.723,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#b7c7de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.945,
    y1: 0.269,
    x2: 0.141,
    y2: 0.858,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.574,
    y1: 0.261,
    x2: 0.164,
    y2: 0.791,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.141,
    y1: 0.289,
    x2: 0.981,
    y2: 0.814,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.09,
    y1: 0.353,
    x2: 0.945,
    y2: 0.867,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.422,
    y1: 0.257,
    x2: 1.126,
    y2: 0.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.173,
    y1: 0.277,
    x2: 0.963,
    y2: 0.891,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e4eaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#cbd7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#bccbe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#b7c7de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#bccbe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#c9d5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#e0e7f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372,
    stopColor: "#c1d0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b2d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#b0afd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a6a5d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#9594c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8282bc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10312",
    "data-name": "Path 10312",
    d: "M129.479,26.9s26.785.237,40.58,21.417c14,21.49,22.826,93.841-50.443,119.485S15.912,105.759,12.53,97.325-18.636,32.72,21.392,8.378C63.047-16.953,66.2,22.851,129.479,26.9Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10313",
    "data-name": "Path 10313",
    d: "M162.179,85.449l-.5-.04.361.35-.247,1.006.627-.828.491.063-.337-.368.279-1.006Z",
    transform: "translate(-65.912 -34.5)",
    fill: "#c8d3d7",
    opacity: 0.31
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10314",
    "data-name": "Path 10314",
    d: "M174.405,93.356a.437.437,0,1,1,.508.351A.437.437,0,0,1,174.405,93.356Z",
    transform: "translate(-71.099 -37.849)",
    fill: "#72a7d3",
    opacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11026",
    "data-name": "Group 11026",
    transform: "translate(94.027 64.01)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10315",
    "data-name": "Path 10315",
    d: "M160.8,108.07a.169.169,0,0,1,.169.262l-1.391,2.015a.169.169,0,1,1-.278-.192l1.391-2.015A.168.168,0,0,1,160.8,108.07Z",
    transform: "translate(-158.959 -108.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10316",
    "data-name": "Path 10316",
    d: "M158.882,108.6a.168.168,0,0,1,.126.027l2.015,1.391a.169.169,0,1,1-.192.278l-2.015-1.391a.169.169,0,0,1,.065-.3Z",
    transform: "translate(-158.744 -108.282)",
    fill: "#fff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10317",
    "data-name": "Path 10317",
    d: "M144.773,98.62l-.727-.057.521.506-.357,1.454.906-1.2.71.09-.487-.531.4-1.454Z",
    transform: "translate(-58.725 -39.721)",
    fill: "#c8d3d7",
    opacity: 0.11
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10318",
    "data-name": "Path 10318",
    d: "M59.274,155.01l1.121-.473-1.159-.349-.586-2.426-.425,2.465-1.12.41,1.129.413.517,2.462Z",
    transform: "translate(-23.28 -61.87)",
    fill: "#029ce0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10319",
    "data-name": "Path 10319",
    d: "M87.675,79.634a.845.845,0,1,1-.845-.845A.845.845,0,0,1,87.675,79.634Z",
    transform: "translate(-35.054 -32.121)",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11027",
    "data-name": "Group 11027",
    transform: "translate(152.295 108.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10320",
    "data-name": "Path 10320",
    d: "M257.4,186.923a.284.284,0,0,1-.2-.484l2.912-2.912a.284.284,0,1,1,.4.4L257.6,186.84a.283.283,0,0,1-.2.083Z",
    transform: "translate(-257.117 -183.444)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10321",
    "data-name": "Path 10321",
    d: "M260.313,186.923a.283.283,0,0,1-.2-.083l-2.912-2.912a.284.284,0,0,1,.4-.4l2.912,2.912a.284.284,0,0,1-.2.484Z",
    transform: "translate(-257.117 -183.444)",
    fill: "#ff6584"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11028",
    "data-name": "Group 11028",
    transform: "translate(21.754 34.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10322",
    "data-name": "Path 10322",
    d: "M37.011,61.39a.284.284,0,0,1-.2-.484l2.912-2.912a.284.284,0,0,1,.4.4l-2.912,2.912a.283.283,0,0,1-.2.083Z",
    transform: "translate(-36.727 -57.911)",
    fill: "#b3b2d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10323",
    "data-name": "Path 10323",
    d: "M39.923,61.39a.283.283,0,0,1-.2-.083L36.811,58.4a.284.284,0,1,1,.4-.4l2.912,2.912a.284.284,0,0,1-.2.484Z",
    transform: "translate(-36.727 -57.911)",
    fill: "#b3b2d8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11031",
    "data-name": "Group 11031",
    transform: "translate(74.511 31.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11029",
    "data-name": "Group 11029"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10324",
    "data-name": "Path 10324",
    d: "M125.855,55.394a.183.183,0,0,1,.113-.319l2.653-.139a.183.183,0,0,1,.019.366l-2.653.14a.183.183,0,0,1-.132-.047Z",
    transform: "translate(-125.795 -53.678)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10325",
    "data-name": "Path 10325",
    d: "M128.117,55.786a.182.182,0,0,1-.06-.126l-.139-2.653a.183.183,0,0,1,.366-.019l.139,2.653a.183.183,0,0,1-.305.146Z",
    transform: "translate(-126.66 -52.813)",
    fill: "#8282bc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11030",
    "data-name": "Group 11030",
    transform: "translate(0.311 0.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10326",
    "data-name": "Path 10326",
    d: "M126.32,53.806a.183.183,0,0,1,.3-.156l2.032,1.712a.183.183,0,0,1-.236.28l-2.032-1.712A.183.183,0,0,1,126.32,53.806Z",
    transform: "translate(-126.32 -53.448)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10327",
    "data-name": "Path 10327",
    d: "M126.59,55.568a.182.182,0,0,1,.042-.134l1.712-2.032a.183.183,0,1,1,.28.236l-1.712,2.032a.183.183,0,0,1-.322-.1Z",
    transform: "translate(-126.43 -53.338)",
    fill: "#8282bc"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10328",
    "data-name": "Path 10328",
    d: "M265.281,111.762l1.193-.5-1.234-.373-.624-2.583-.453,2.625-1.193.437,1.2.441.549,2.621Z",
    transform: "translate(-107.208 -44.153)",
    fill: "#f2f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10329",
    "data-name": "Path 10329",
    d: "M77.263,136.786a.6.6,0,1,1-.6-.6A.6.6,0,0,1,77.263,136.786Z",
    transform: "translate(-31.006 -55.519)",
    fill: "#ff6584"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10330",
    "data-name": "Path 10330",
    d: "M183.735,229.287c-14.507-12.5-54.665-39.144-105.406-6.324-8.628,5.581-4.817,17.023,2.735,23.512,18.389,15.8,52.449,38.286,102.4-6.6C186.682,236.991,187.009,232.108,183.735,229.287Z",
    transform: "translate(-29.919 -84.471)",
    fill: "#b3b2d8"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11033",
    "data-name": "Group 11033",
    transform: "translate(42.43 132.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11032",
    "data-name": "Group 11032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10331",
    "data-name": "Path 10331",
    d: "M128.241,263.187s7.307-1.862,10.606.611c2.482,1.86-4.337,4.28-9.281,3.337a1.183,1.183,0,0,1-.538-1.287c.425-1.92,3.162-2.276,3.162-2.276s-2.864,0-3.688,1.1a5.566,5.566,0,0,0-.719,1.931,4.846,4.846,0,0,1-2.091-1.626s-1.318,4.432,8.439,3.474,8.886-4.812,4.454-6.13S128.241,263.187,128.241,263.187Z",
    transform: "translate(-93.648 -239.582)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10332",
    "data-name": "Path 10332",
    d: "M165.594,230.64s7.41-1.4,10.547,1.276c2.36,2.012-4.6,4-9.472,2.747a1.184,1.184,0,0,1-.456-1.319c.545-1.89,3.3-2.072,3.3-2.072s-2.858-.184-3.75.862a5.567,5.567,0,0,0-.839,1.882,4.846,4.846,0,0,1-1.984-1.754s-1.594,4.34,8.2,4,9.171-4.244,4.831-5.838S165.594,230.64,165.594,230.64Z",
    transform: "translate(-108.818 -226.484)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10333",
    "data-name": "Path 10333",
    d: "M134.085,227.375s4.02-1.072,5.856.272c1.381,1.011-2.366,2.388-5.1,1.9a.653.653,0,0,1-.3-.707c.223-1.062,1.731-1.275,1.731-1.275s-1.58.016-2.028.627a3.072,3.072,0,0,0-.385,1.07,2.674,2.674,0,0,1-1.163-.884s-.7,2.454,4.678,1.865,4.873-2.71,2.42-3.41S134.085,227.375,134.085,227.375Z",
    transform: "translate(-96.513 -225.2)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10334",
    "data-name": "Path 10334",
    d: "M228.515,253.613s4.956.407,6.483,2.656c1.149,1.692-3.622,1.738-6.5.09a.781.781,0,0,1-.06-.918c.677-1.106,2.46-.741,2.46-.741s-1.785-.617-2.535-.108a3.671,3.671,0,0,0-.863,1.05,3.2,3.2,0,0,1-.955-1.462s-1.773,2.481,4.517,3.977,6.573-1.095,4.093-2.867S228.515,253.613,228.515,253.613Z",
    transform: "translate(-134.693 -236.205)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10335",
    "data-name": "Path 10335",
    d: "M221.048,243.807s3.606.3,4.717,1.933c.836,1.231-2.636,1.265-4.732.066a.568.568,0,0,1-.043-.668c.492-.8,1.79-.539,1.79-.539s-1.3-.449-1.844-.078a2.671,2.671,0,0,0-.628.764,2.325,2.325,0,0,1-.695-1.064s-1.29,1.805,3.287,2.894,4.783-.8,2.978-2.086A9.424,9.424,0,0,0,221.048,243.807Z",
    transform: "translate(-131.894 -232.208)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10336",
    "data-name": "Path 10336",
    d: "M252.665,247.74s2.029.582,2.478,1.646c.337.8-1.653.422-2.715-.5a.331.331,0,0,1,.052-.387c.374-.4,1.086-.1,1.086-.1s-.692-.406-1.046-.256a1.56,1.56,0,0,0-.447.365,1.357,1.357,0,0,1-.276-.688s-.945.885,1.549,2.032,2.828.092,1.943-.853a5.5,5.5,0,0,0-2.624-1.251Z",
    transform: "translate(-145.011 -233.811)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10337",
    "data-name": "Path 10337",
    d: "M154.9,244.9s4.92-.928,7,.847c1.567,1.336-3.052,2.655-6.289,1.824a.786.786,0,0,1-.3-.876c.362-1.255,2.19-1.376,2.19-1.376s-1.9-.122-2.49.572a3.7,3.7,0,0,0-.557,1.249,3.217,3.217,0,0,1-1.317-1.165s-1.058,2.882,5.447,2.655,6.09-2.818,3.208-3.876S154.9,244.9,154.9,244.9Z",
    transform: "translate(-104.835 -232.417)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10338",
    "data-name": "Path 10338",
    d: "M196.376,243.374s3.283-.389,4.575.875c.972.951-2.131,1.611-4.226.917a.519.519,0,0,1-.16-.591c.3-.81,1.505-.807,1.505-.807s-1.245-.166-1.666.264a2.44,2.44,0,0,0-.423.8,2.124,2.124,0,0,1-.815-.827s-.828,1.851,3.469,2,4.139-1.581,2.288-2.409A8.612,8.612,0,0,0,196.376,243.374Z",
    transform: "translate(-121.969 -231.943)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10339",
    "data-name": "Path 10339",
    d: "M209.414,224.227s3.3.218,4.338,1.7c.782,1.113-2.39,1.194-4.322.129a.519.519,0,0,1-.049-.61c.438-.743,1.627-.519,1.627-.519s-1.193-.391-1.686-.045a2.441,2.441,0,0,0-.562.707,2.125,2.125,0,0,1-.65-.962s-1.152,1.668,3.045,2.6,4.358-.8,2.69-1.95A8.612,8.612,0,0,0,209.414,224.227Z",
    transform: "translate(-127.213 -224.225)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10340",
    "data-name": "Path 10340",
    d: "M175.371,252.242s1.531-.182,2.133.408c.453.443-.994.751-1.97.428a.242.242,0,0,1-.075-.275c.138-.378.7-.377.7-.377s-.58-.077-.777.123a1.138,1.138,0,0,0-.2.372.991.991,0,0,1-.38-.386s-.386.863,1.617.93,1.93-.737,1.067-1.123a4.015,4.015,0,0,0-2.12-.1Z",
    transform: "translate(-113.683 -235.607)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10341",
    "data-name": "Path 10341",
    d: "M109.051,245.686s3.323-1.4,5.059-.465c1.306.7-1.747,2.332-4.152,2.238a.566.566,0,0,1-.346-.571c.065-.938,1.334-1.3,1.334-1.3s-1.355.2-1.666.78a2.662,2.662,0,0,0-.2.964,2.317,2.317,0,0,1-1.1-.62s-.308,2.19,4.238,1.044,3.861-2.907,1.671-3.216A9.393,9.393,0,0,0,109.051,245.686Z",
    transform: "translate(-86.447 -232.489)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10342",
    "data-name": "Path 10342",
    d: "M82.9,236.663s1.932-1.348,3.169-.988c.93.271-.8,1.728-2.347,2a.37.37,0,0,1-.3-.317c-.087-.608.674-1.013.674-1.013s-.838.314-.958.726a1.739,1.739,0,0,0,0,.644,1.514,1.514,0,0,1-.79-.246s.1,1.441,2.85.088,2.069-2.385.628-2.283A6.136,6.136,0,0,0,82.9,236.663Z",
    transform: "translate(-76.002 -228.725)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10343",
    "data-name": "Path 10343",
    d: "M197.035,272.1s2.769-.452,3.912.571c.86.77-1.747,1.445-3.549.935a.44.44,0,0,1-.158-.495c.22-.7,1.246-.741,1.246-.741s-1.061-.095-1.4.286a2.071,2.071,0,0,0-.329.692,1.8,1.8,0,0,1-.722-.671s-.633,1.6,3.015,1.562,3.45-1.495,1.85-2.128A7.309,7.309,0,0,0,197.035,272.1Z",
    transform: "translate(-122.331 -243.632)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10344",
    "data-name": "Path 10344",
    d: "M86.794,271.21s1.671-1.344,2.816-1.093c.862.188-.617,1.619-2.007,1.958a.337.337,0,0,1-.291-.27c-.117-.547.55-.962.55-.962s-.741.337-.825.719a1.582,1.582,0,0,0,.042.584,1.378,1.378,0,0,1-.733-.174s.182,1.3,2.593-.1,1.731-2.293.429-2.111A5.585,5.585,0,0,0,86.794,271.21Z",
    transform: "translate(-77.631 -242.781)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10345",
    "data-name": "Path 10345",
    d: "M89.607,258.213S91,256.87,92.052,257c.79.1-.424,1.506-1.647,1.924a.3.3,0,0,1-.284-.219c-.149-.483.417-.909.417-.909s-.64.363-.684.713a1.431,1.431,0,0,0,.085.522,1.244,1.244,0,0,1-.673-.1s.269,1.156,2.325-.3,1.372-2.2.215-1.934A5.044,5.044,0,0,0,89.607,258.213Z",
    transform: "translate(-78.821 -237.444)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10346",
    "data-name": "Path 10346",
    d: "M71.732,254.175s.584-.868,1.154-.916c.429-.037-.054.844-.652,1.2a.164.164,0,0,1-.175-.084c-.133-.238.117-.528.117-.528s-.3.264-.28.454a.772.772,0,0,0,.1.266.672.672,0,0,1-.367.025s.273.58,1.194-.42.475-1.319-.105-1.046a2.725,2.725,0,0,0-.99,1.046Z",
    transform: "translate(-71.633 -235.971)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10347",
    "data-name": "Path 10347",
    d: "M106.012,229.423s2.727-1.215,4.181-.471c1.093.56-1.406,1.961-3.4,1.924a.469.469,0,0,1-.3-.466c.037-.778,1.082-1.1,1.082-1.1s-1.118.19-1.366.674a2.2,2.2,0,0,0-.151.8,1.919,1.919,0,0,1-.925-.495s-.218,1.818,3.526.791,3.146-2.473,1.328-2.691A7.779,7.779,0,0,0,106.012,229.423Z",
    transform: "translate(-85.291 -225.913)",
    fill: "#8282bc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10348",
    "data-name": "Path 10348",
    d: "M204.952,279.248s-5.394.052-7.222,2.366c-1.376,1.741,3.783,2.164,7.029.607a.847.847,0,0,0,.136-.989c-.646-1.25-2.6-.994-2.6-.994s1.98-.528,2.751.082a3.983,3.983,0,0,1,.851,1.2,3.467,3.467,0,0,0,1.148-1.508s1.724,2.823-5.2,3.949-7.027-1.7-4.2-3.423S204.952,279.248,204.952,279.248Z",
    transform: "translate(-122.295 -246.637)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10349",
    "data-name": "Path 10349",
    d: "M171.8,281.292s-5.6-.386-7.689,1.867c-1.57,1.695,3.75,2.555,7.246,1.2a.881.881,0,0,0,.222-1.015c-.568-1.35-2.621-1.244-2.621-1.244s2.1-.386,2.849.309a4.146,4.146,0,0,1,.785,1.318,3.609,3.609,0,0,0,1.314-1.471s1.559,3.07-5.718,3.675-7.155-2.336-4.084-3.9S171.8,281.292,171.8,281.292Z",
    transform: "translate(-108.522 -247.404)",
    fill: "#8282bc"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10350",
    "data-name": "Path 10350",
    d: "M163.463,217.988q0-.77-4.971-1.324a112.907,112.907,0,0,0-12-.543,112.9,112.9,0,0,0-12,.543q-4.97.553-4.97,1.324t4.97,1.053q4.971.282,12,.217t12-.282Q163.462,218.759,163.463,217.988Z",
    transform: "translate(-52.8 -88.107)",
    fill: "#8282bc"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10351",
    "data-name": "Path 10351",
    d: "M191.647,221.829q0,.21.8.361a12.517,12.517,0,0,0,3.84,0q.8-.151.8-.361t-.8-.287a17.455,17.455,0,0,0-1.92-.059q-1.125.018-1.92.077T191.647,221.829Z",
    transform: "translate(-78.131 -90.292)",
    fill: "#8282bc"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11036",
    "data-name": "Group 11036",
    transform: "translate(61.646 33.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10352",
    "data-name": "Path 10352",
    d: "M4.816,0H27.773a4.816,4.816,0,0,1,4.816,4.816V27.006a4.816,4.816,0,0,1-4.816,4.816H4.816A4.816,4.816,0,0,1,0,27.006V4.816A4.816,4.816,0,0,1,4.816,0Z",
    transform: "translate(15.406 36.903) rotate(-0.209)",
    fill: "#8282bc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11034",
    "data-name": "Group 11034",
    transform: "translate(0 38.212)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1030",
    "data-name": "Rectangle 1030",
    width: 24.741,
    height: 31.775,
    transform: "translate(19.335 0.091) rotate(-0.209)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10353",
    "data-name": "Path 10353",
    d: "M137.89,121.135a1.83,1.83,0,0,0,1.041.906c2.528,1,5.592,1.445,9.955,1.429,5.642-.021,9.608-.516,12.248-2.419l-23.244.085Z",
    transform: "translate(-117.861 -121.045)",
    fill: "#b3b2d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1031",
    "data-name": "Rectangle 1031",
    width: 9.178,
    height: 11.944,
    transform: "translate(19.444 31.593) rotate(-0.209)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1032",
    "data-name": "Rectangle 1032",
    width: 9.178,
    height: 0.873,
    transform: "translate(19.487 43.537) rotate(-0.209)",
    fill: "#b3b2d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10354",
    "data-name": "Path 10354",
    d: "M145.746,209.354l-9.178.033-.721-12.912a.455.455,0,0,1,.452-.48l9.518-.035a.458.458,0,0,1,.459.477Z",
    transform: "translate(-117.029 -151.584)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10355",
    "data-name": "Path 10355",
    d: "M132.915,215.062a.451.451,0,0,1-.444-.357c-.272-1.258-.9-5.369,2.611-4.789,4.143.683,7.551,5.11,7.551,5.11Z",
    transform: "translate(-115.56 -157.251)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1033",
    "data-name": "Rectangle 1033",
    width: 9.178,
    height: 11.944,
    transform: "translate(44.241 43.448) rotate(179.791)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1034",
    "data-name": "Rectangle 1034",
    width: 9.178,
    height: 0.873,
    transform: "translate(44.245 44.32) rotate(179.791)",
    fill: "#b3b2d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10356",
    "data-name": "Path 10356",
    d: "M162.93,209.291l9.178-.034.626-12.916a.456.456,0,0,0-.457-.478l-9.521.035a.453.453,0,0,0-.451.475Z",
    transform: "translate(-127.815 -151.544)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10357",
    "data-name": "Path 10357",
    d: "M175.856,214.891a.452.452,0,0,0,.443-.361c.263-1.261.865-5.374-2.646-4.769-4.138.713-7.513,5.165-7.513,5.165Z",
    transform: "translate(-129.378 -157.185)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10358",
    "data-name": "Path 10358",
    d: "M187.025,151.09l7.806-4.828-5.525-9.979a.456.456,0,0,0-.639-.167l-8.375,5.18Z",
    transform: "translate(-135.148 -127.158)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1035",
    "data-name": "Rectangle 1035",
    width: 9.178,
    height: 0.374,
    transform: "translate(59.879 19.422) rotate(148.26)",
    fill: "#b3b2d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10359",
    "data-name": "Path 10359",
    d: "M202.31,158.506l-2.893-4.676-5.478,3.388h0l-2.327,1.44.022.035-.559,3.546a1.347,1.347,0,0,0,2.661.42l.071-.453,1.393,2.252a2.955,2.955,0,0,0,4.068.959l1.654-1.023A4.277,4.277,0,0,0,202.31,158.506Z",
    transform: "translate(-139.537 -134.408)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10360",
    "data-name": "Path 10360",
    d: "M188.589,135.66a2.148,2.148,0,0,0-1.055-1.439l-6.287,5.981Z",
    transform: "translate(-135.537 -126.414)",
    fill: "#b3b2d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10361",
    "data-name": "Path 10361",
    d: "M180.113,122.7l-1.151,12.106.99,1.041,6.65-6.326Z",
    transform: "translate(-134.606 -121.719)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10362",
    "data-name": "Path 10362",
    d: "M178.49,121.041a1.468,1.468,0,0,1,1.431.985l-1.151,12.106-.232-.039Z",
    transform: "translate(-134.413 -121.04)",
    fill: "#b3b2d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10363",
    "data-name": "Path 10363",
    d: "M118.187,151.261l-7.8-4.836,5.537-9.976a.453.453,0,0,1,.635-.165l8.372,5.19Z",
    transform: "translate(-106.649 -127.227)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1036",
    "data-name": "Rectangle 1036",
    width: 9.185,
    height: 0.374,
    transform: "translate(3.738 19.198) rotate(31.797)",
    fill: "#b3b2d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10364",
    "data-name": "Path 10364",
    d: "M104.719,158.663l2.9-4.673,5.474,3.394h0l2.326,1.442-.022.035.556,3.547a1.347,1.347,0,1,1-2.661.417l-.071-.453-1.4,2.251a2.955,2.955,0,0,1-4.069.955l-1.653-1.025A4.277,4.277,0,0,1,104.719,158.663Z",
    transform: "translate(-104.076 -134.473)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10365",
    "data-name": "Path 10365",
    d: "M121.6,135.832a2.148,2.148,0,0,1,1.057-1.438l6.281,5.987Z",
    transform: "translate(-111.22 -126.484)",
    fill: "#b3b2d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10366",
    "data-name": "Path 10366",
    d: "M129.879,122.888,131.017,135l-.991,1.04-6.644-6.332Z",
    transform: "translate(-111.947 -121.794)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10367",
    "data-name": "Path 10367",
    d: "M135.781,121.228a1.468,1.468,0,0,0-1.432.983l1.139,12.107.232-.039Z",
    transform: "translate(-116.418 -121.116)",
    fill: "#b3b2d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1037",
    "data-name": "Rectangle 1037",
    width: 16.162,
    height: 9.414,
    rx: 4.707,
    transform: "translate(23.655 8.387) rotate(-0.209)",
    fill: "#b3b2d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1038",
    "data-name": "Rectangle 1038",
    width: 15.214,
    height: 8.58,
    rx: 4.29,
    transform: "translate(24.131 8.802) rotate(-0.209)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10368",
    "data-name": "Path 10368",
    d: "M151.182,141.82a1.4,1.4,0,1,1-1.408-1.4A1.4,1.4,0,0,1,151.182,141.82Z",
    transform: "translate(-122.136 -128.942)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1039",
    "data-name": "Rectangle 1039",
    width: 7.111,
    height: 0.711,
    rx: 0.355,
    transform: "translate(31.103 9.869) rotate(-0.209)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1040",
    "data-name": "Rectangle 1040",
    width: 7.111,
    height: 0.711,
    rx: 0.355,
    transform: "translate(31.108 11.29) rotate(-0.209)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1041",
    "data-name": "Rectangle 1041",
    width: 7.111,
    height: 0.711,
    rx: 0.355,
    transform: "translate(31.113 12.711) rotate(-0.209)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1042",
    "data-name": "Rectangle 1042",
    width: 7.111,
    height: 0.711,
    rx: 0.355,
    transform: "translate(31.118 14.132) rotate(-0.209)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1043",
    "data-name": "Rectangle 1043",
    width: 7.111,
    height: 0.711,
    rx: 0.355,
    transform: "translate(31.124 15.553) rotate(-0.209)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10369",
    "data-name": "Path 10369",
    d: "M136.813,142.119l4.058-.015,0,1.2-4.058.015a.573.573,0,0,1-.547-.6h0A.574.574,0,0,1,136.813,142.119Z",
    transform: "translate(-117.201 -129.628)",
    fill: "#b3b2d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10370",
    "data-name": "Path 10370",
    d: "M175.308,143.22l-4,.015,0-1.2,4-.015a.57.57,0,0,1,.538.6h0A.57.57,0,0,1,175.308,143.22Z",
    transform: "translate(-131.486 -129.594)",
    fill: "#b3b2d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10371",
    "data-name": "Path 10371",
    d: "M159.158,155.073l-21.716.079c-2.957.011-2.85,2.791-2.837,6.221h0c.013,3.43-.074,6.211,2.882,6.2l21.716-.079c2.957-.011,2.849-2.791,2.837-6.221h0C162.028,157.843,162.115,155.062,159.158,155.073Z",
    transform: "translate(-116.521 -134.915)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11035",
    "data-name": "Group 11035",
    transform: "translate(8.747)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 16.682,
    cy: 16.682,
    r: 16.682,
    transform: "matrix(0.517, -0.856, 0.856, 0.517, 0, 28.56)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 15.973,
    cy: 13.057,
    rx: 15.973,
    ry: 13.057,
    transform: "translate(6.886 11.081) rotate(-0.209)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 15.561,
    cy: 12.72,
    rx: 15.561,
    ry: 12.72,
    transform: "translate(7.3 11.416) rotate(-0.209)",
    fill: "#029ce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10372",
    "data-name": "Path 10372",
    d: "M143.534,84.214c-.494-1.369-2.186-1.412-3.928.255s-2.416,3.271-1.563,4.024c1.156,1.02,2.223,1,3.8-.84C142.817,86.518,144.054,85.656,143.534,84.214Z",
    transform: "translate(-126.52 -67.402)",
    fill: "url(#linear-gradient-4)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11037",
    "data-name": "Group 11037",
    transform: "translate(115.41 55.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10373",
    "data-name": "Path 10373",
    d: "M196.408,114.464h-1.133v55.1a1.564,1.564,0,0,0,1.133,0v-55.1M195.275,94.1v.425h1.133V94.1a.567.567,0,1,0-1.133,0Z",
    transform: "translate(-195.02 -93.538)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10374",
    "data-name": "Path 10374",
    d: "M195.1,95.212h-.255v19.934h26.14V95.212H195.1",
    transform: "translate(-194.844 -94.22)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d4c636ea7ceb63a976676e145ea3d894.svg";
export { ForwardRef as ReactComponent };